<div class="flxClmn bs-enabled animated fadeIn" style="flex: 1 0; position: relative;"
	 [ngStyle]="{'overflow' : generatePdfInProcess ? 'hidden' : 'auto'}">
	<!--generate pdf loader-->
	<div *ngIf="generatePdfInProcess" class="pdf-generate-loader" style="left: 0; width: 100%; height: 100%;">
		<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); align-items: center;"
			 class="flxClmn vSpace2">
			<loader height="80" width="80" style="opacity: 0.8;"></loader>
			<span style="position: relative; font-size: 1rem; font-weight: 500; color: var(--ui-text-muted);" class="loading-dots">Generating PDF. Please wait</span>
		</div>
	</div>
	<!---->

	<div class="flxRow gap-2" style="align-items: center; justify-content: space-between;">
		<div class="flxRow gap-2">
			<btn-c endIcon="far fa-sync-alt"
				   variant="outlined"
				   (action)="getSummaryData();">
				Refresh
			</btn-c>
			<btn-c endIcon="far fa-file-download" variant="outlined"
				   [isDisabled]="generatePdfInProcess"
				   (action)="exportChartsToPdf();">
				Export to PDF
			</btn-c>
		</div>
	</div>


	<div class="flxClmn bs-enabled f-1-0 mt-2" style="padding: 5px;" id="trendsChartsContainer">
		<div class="bs-row trends-pdf-page-title" style="display: none;">
			<img class="mb-3" [src]="lfs.logo" style="width: 200px;"/>
		</div>
		<div class="trends-pdf-page-title" style="display: none;">
			<div class="flxClmn vSpace05 w-100 mb-5">
				<div class="flxRow-between" style="align-items: flex-end;">
					<span style="font-weight: bold; font-size: 1.6rem; white-space: nowrap;">Threat Simulation Campaign Summary - "{{currentCampaign.name}}"</span>
					<span style="font-size: 1.25rem; white-space: nowrap;">
						Date printed: &nbsp;
						<time>{{currentCampaign.created | date:'MM/dd/yyyy'}}</time>
					</span>
				</div>
				<div class="flxRow hSpace05" style="font-size: 1.25rem;" *ngIf="currentCampaign.description">
					<span>Campaign description:&nbsp;</span>
					<span>{{currentCampaign.description}}</span>
				</div>
				<div class="flxRow hSpace05" style="font-size: 1.25rem;">
					<span>Recipients:&nbsp;</span>
					<span>{{currentCampaign.recipients_count}}</span>
				</div>
				<div class="flxRow hSpace05" style="font-size: 1.25rem;">
					<span>Sent at:&nbsp;</span>
					<span>{{(currentCampaign.email_id?.start_sending_time || currentCampaign.created) | date:'MM/dd/yyyy HH:mm'}}</span>
				</div>
			</div>
		</div>

		<div class="flex-row flex-wrap gap-3 f-1-0">
			<div class="trends-data-card h-auto flex-column gap-2 p-3 animated fadeIn f-1-0" style="min-width: 380px; min-height: 300px; max-height: 400px;"
			     [ngStyle]="{'border' : generatePdfInProcess ? 'solid 2px dimgrey' : ''}">
				<div class="flex-column align-items-start gap-1">
					<div class="flex-row align-items-center gap-1">
						<h6 class="m-0 fw-bold text-nowrap">Campaign Result Distribution</h6>
					</div>

					<span class="opacity-75 fw-500 text-start">
						See the distribution of outcomes across all targeted users - providing insights into user engagement and campaign impact
					</span>
				</div>
				<div class="flex-column f-1-0 animated fadeIn">
					<apx-chart class="pie-chart-left f-1-0"
					           *ngIf="!getSummaryInProcess"
					           [series]="recipientsStatusChartOptions?.series"
					           [chart]="recipientsStatusChartOptions?.chart"
					           [plotOptions]="recipientsStatusChartOptions?.plotOptions"
					           [colors]="recipientsStatusChartOptions?.colors"
					           [legend]="recipientsStatusChartOptions?.legend"
					           [labels]="recipientsStatusChartOptions?.labels"></apx-chart>
				</div>
				<!--loader / placeholder-->
				<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="getSummaryInProcess">
					<div class="flex-column text-center centralize f-1-0">
						<loader class="opacity-75 align-self-center" height="100" width="100"></loader>
					</div>
				</div>
			</div>

			<!--Campaign Metrics-->
			<div class="trends-data-card h-auto flex-column p-3 gap-2 animated fadeIn f-1-0" style="min-width: 300px; min-height: 300px; max-height: 400px;"
				 [ngStyle]="{'border' : generatePdfInProcess ? 'solid 2px dimgrey' : ''}">
				<div class="flex-column align-items-start gap-1">
					<div class="flex-row align-items-center gap-1">
						<h6 class="m-0 fw-bold text-nowrap">Campaign Metrics</h6>
					</div>

					<span class="opacity-75 fw-500 text-start">
						Visualize the engagement levels of your recipients for this campaign, tracking the total number user interactions
					</span>
				</div>
				<div class="flex-column f-1-0 animated fadeIn">
					<apx-chart class="trends-radial-pie-chart visible-legend f-1-0"
							   *ngIf="generalEventsChartOptions?.maxValue && !getSummaryInProcess"
							   [series]="generalEventsChartOptions?.series"
							   [chart]="generalEventsChartOptions?.chart"
							   [plotOptions]="generalEventsChartOptions?.plotOptions"
							   [colors]="generalEventsChartOptions?.colors"
							   [legend]="generalEventsChartOptions?.legend"
							   [labels]="generalEventsChartOptions?.labels"></apx-chart>
				</div>
				<!--loader / placeholder-->
				<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!generalEventsChartOptions?.maxValue || getSummaryInProcess">
					<div class="flex-column text-center centralize f-1-0">
						<span class="fw-500 opacity-75" *ngIf="!getSummaryInProcess">No data</span>
						<loader class="opacity-75 align-self-center" *ngIf="getSummaryInProcess" height="100" width="100"></loader>
					</div>
				</div>
			</div>

			<!--Quiz Events-->
			<div class="trends-data-card h-auto flex-column gap-2 p-3 animated fadeIn f-1-0" style="min-width: 380px; min-height: 300px; max-height: 400px;"
				 *ngIf="currentCampaign.ts_type === dic.CONSTANTS.threatSimulationType.quiz.value"
				 [ngStyle]="{'border' : generatePdfInProcess ? 'solid 2px dimgrey' : ''}">
				<div class="flex-column align-items-start gap-1">
					<div class="flex-row align-items-center gap-1">
						<h6 class="m-0 fw-bold text-nowrap">Quiz Success Rate Analysis</h6>
					</div>

					<span class="opacity-75 fw-500 text-start">
						Measure the success of your security awareness campaign by evaluating user accuracy in quiz responses, reflecting both engagement and learning outcomes.
					</span>
				</div>
				<div class="flex-column f-1-0 animated fadeIn">
					<apx-chart class="pie-chart-left f-1-0"
							   *ngIf="quizEventsChartOptions && !getSummaryInProcess"
							   [series]="quizEventsChartOptions?.series"
							   [chart]="quizEventsChartOptions?.chart"
							   [colors]="quizEventsChartOptions?.colors"
							   [labels]="quizEventsChartOptions?.labels"></apx-chart>
				</div>
				<!--loader / placeholder-->
				<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!quizEventsChartOptions || getSummaryInProcess">
					<div class="flex-column text-center centralize f-1-0">
						<span class="fw-500 opacity-75" *ngIf="!getSummaryInProcess">No data</span>
						<loader class="opacity-75 align-self-center" *ngIf="getSummaryInProcess" height="100" width="100"></loader>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

